enum CostMode {
  ContributingEpics = 'contributing_epics',
  ContributingTeams = 'contributing_teams',
  ContributingInitiatives = 'contributing_initiatives',
}

enum ChartDataType {
  Epic = 'epic',
  Team = 'team',
  Initiative = 'initiative',
  Other = 'other',
}

type ChartDataItem = {
  id: string;
  title: string;
  name?: string;
  size: number;
  actualSize: number;
  percentage: number;
  fill?: string;
  type?: ChartDataType;
  otherEpicsData?: Record<string, { title: string; size: number; percentage: number }>;
  otherTeamsData?: Record<string, { title: string; size: number; percentage: number }>;
  otherInitiativesData?: Record<string, { title: string; size: number; percentage: number }>;
};

export { ChartDataType, CostMode };
export type { ChartDataItem };
